const routes = [
  /* {
    path: '/',
    redirect: () => {
      return '/auth-assessment/login';
    },
  }, */
  {
    path: 'login',
    name: 'assessmentLogin',
    component: () => import(/* webpackChunkName: "login" */ '@/view/auth-assessment/SignIn.vue'),
  },
  {
    path: 'register',
    name: 'assessmentRegister',
    component: () => import(/* webpackChunkName: "register" */ '@/view/auth-assessment/Signup.vue'),
  },
  {
    path: 'forgot-password',
    name: 'assessmentForgotPassword',
    component: () => import(/* webpackChunkName: "forgotPassword" */ '@/view/auth-assessment/ForgotPassword.vue'),
  },
  {
    path: 'first-login',
    name: 'assessmentFirstLogin',
    component: () => import(/* webpackChunkName: "firstLogin" */ '@/view/auth-assessment/FirstLogin.vue'),
  },
  {
    path: 'update-password',
    name: 'assessmentUpdatePassword',
    component: () => import(/* webpackChunkName: "updatePassword" */ '@/view/auth-assessment/UpdatePassword.vue'),
  },
];

export default routes;
